import ProductStackPillNavigation from './ProductStackPillNavigation'
import ProductStackTiles from './ProductStackTiles'

export default class ProductStack {
    constructor(productStack) {
        this.productStack = productStack
        this.tiles = new ProductStackTiles(this.productStack)
        this.pillNavigation = new ProductStackPillNavigation(this.productStack, this.tiles)
    }
}
